import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Label } from "reactstrap";

export const LegendaNormalCirculo = (props) => <div><FontAwesomeIcon icon="circle" size={ props.tamanho ? props.tamanho : "xs" } className={ props.className ? `icone ${props.className}` : "icone" } color="green" />&nbsp;&nbsp;&nbsp; { props.label ? props.label : "" } </div>;

export const LegendaGoldCirculo = (props) => <div><FontAwesomeIcon icon="circle" size={ props.tamanho ? props.tamanho : "xs" } className={ props.className ? `icone ${props.className}` : "icone" } color="yellow" />&nbsp;&nbsp;&nbsp; { props.label ? props.label : "" } </div>;

export const LegendaEsgotadoCirculo = (props) => <div><FontAwesomeIcon icon="circle" size={ props.tamanho ? props.tamanho : "xs" } className={ props.className ? `icone ${props.className}` : "icone" } color="red" />&nbsp;&nbsp;&nbsp; { props.label ? props.label : "" } </div>;

export const LegendaIndisponivelCirculo = (props) => <div><FontAwesomeIcon icon="circle" size={ props.tamanho ? props.tamanho : "xs" } className={ props.className ? `icone ${props.className}` : "icone" } color="gray" />&nbsp;&nbsp;&nbsp; { props.label ? props.label : "" } </div>;



// WEBPACK FOOTER //
// ./src/modules/comum/components/Legenda.js